import {allowedDomains} from "~/utils/getThemeFromUrl";

const getThemeFromLastLocation = (url) => {

    if(!url){
        return undefined;
    }
    // Remove leading and trailing slashes to ensure consistent parsing
    const trimmedUrl = url.replace(/^\/|\/$/g, '');

    // Split the URL by slashes and get the first element
    const theme = trimmedUrl.split('/')[0];

    return allowedDomains.includes(theme) ? trimmedUrl.split('/')[0] : undefined;
};

export default getThemeFromLastLocation;
